import {SvgIconProps} from "@mui/material/SvgIcon/SvgIcon";
import {Office} from "../../api/Model";
import BerlinIcon from "../icons/BerlinIcon";
import MunichIcon from "../icons/MunichIcon";
import AmsterdamIcon from "../icons/AmsterdamIcon";
import PragueIcon from "../icons/PragueIcon";
import WarsawIcon from "../icons/WarsawIcon";
import YerevanIcon from "../icons/YerevanIcon";
import React, {ComponentType, createElement, useMemo} from "react";
import {Stack} from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PaphosIcon from "../icons/PaphosIcon";
import LimassolIcon from "../icons/LimassolIcon";

export const officeIcons: { officeId: Office['id'], icon: ComponentType<SvgIconProps & { colored: boolean }> }[] = [
    {officeId: 272017, icon: BerlinIcon},
    {officeId: 266186, icon: MunichIcon},
    {officeId: 272013, icon: AmsterdamIcon},
    {officeId: 272014, icon: AmsterdamIcon},
    {officeId: 272015, icon: PaphosIcon},
    {officeId: 272016, icon: LimassolIcon},
    {officeId: 272012, icon: PragueIcon},
    {officeId: 329455, icon: WarsawIcon},
    {officeId: 329456, icon: WarsawIcon},
    {officeId: 272019, icon: YerevanIcon},
];

export function OfficeIconGallery({fontSize = '128px'}: {
    fontSize?: string,
}) {
    const uniqueOfficeIcons = useMemo(() =>
            [...new Set(officeIcons.map(({icon}) => icon))],
        [],
    );

    return (
        <Stack direction="column" spacing={1}>
            <Stack direction="row" gap={1}>
                {uniqueOfficeIcons.map(icon => (
                    createElement(icon, {colored: true, sx: {border: '1px solid #ccc', fontSize: fontSize}})
                ))}
            </Stack>
            <Stack direction="row" gap={1}>
                {uniqueOfficeIcons.map(icon => (
                    createElement(icon, {colored: false, sx: {border: '1px solid #ccc', fontSize: fontSize}})
                ))}
            </Stack>
        </Stack>
    );
}

export function OfficeIcon({officeId, office, colored = false, ...props}: ({
    officeId: Office['id'],
    office?: never,
} | {
    officeId?: never,
    office: Office,
}) & {
    colored?: boolean,
} & SvgIconProps) {
    const officeIdToUse = office ? office.id : officeId;
    const iconToUse = officeIcons
        .find(({officeId}) => officeId === officeIdToUse)
        ?.icon;

    return iconToUse ? (
        createElement(iconToUse, {colored, ...props})
    ) : (
        <ApartmentIcon {...props} color={colored ? 'disabled' : undefined}/>
    );
}
